import { ActiveCart, ActiveCartGiftWithPurchases } from 'types/cart';

// for now only allow to 1 promo active in parallel
export const isTherePromosButNotASinglePromoClaimed = ({
  cart,
  giftWithPurchases,
}:
  | {
      cart?: ActiveCart;
      giftWithPurchases?: never;
    }
  | {
      cart?: never;
      giftWithPurchases?: Array<ActiveCartGiftWithPurchases>;
    }): boolean => {
  const promos = cart?.giftWithPurchases || giftWithPurchases;
  if (!promos || !promos.length) return false;

  return !Boolean(promos?.find(e => e.fullfilled));
};
